<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="company">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}客诉
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(customerComplaintTypeEdit && company.id != null)
                     || (customerComplaintTypeAdd && company.id == null)"
                     @click="saveData">保存
          </el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>

                <!--                  <th>
                                      <em class="f-red">*</em>
                                    品牌ID
                                  </th>
                                  <td>
                                    <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                                      <el-select v-model="company.companyId">
                                        <el-option v-for="item in brand" :key="item.value" :label="item.label" :value="item.value"
                                          :disabled="item.disabled">
                                        </el-option>
                                      </el-select>
                                    </el-form-item>
                                  </td>-->
                <th>
                  <em class="f-red">*</em>
                  客诉编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.code" @blur="inspection" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  客诉名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.name" clearable/>
                </td>
      <th>
                  <em class="f-red">*</em>
                  客诉层级
                </th>
                <td>
                  <!--                    <el-input type="text" autocomplete="off" v-model="company.itemModel" clearable />-->
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="company.level" @change='levelChange(company.level)'>
                      <el-option label="父级" :value=0></el-option>
                      <el-option label="一级" :value=1></el-option>
                      <el-option label="二级" :value=2></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <th>
                  客诉父级
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <!-- <el-cascader v-model="idName" :options="options1" @change="handleChange" clearable>
                    </el-cascader> -->

                    <el-select v-model="parentId_one" placeholder="选择父级" @change='selectOne(parentId_one)' clearable
                               style="width: 49%!important;" :disabled="disabled_one">
                      <!--                        <el-option v-for="item in options" :key="item.value" :label="item.label"-->
                      <!--                          :value="{value:item.value,label:item.label,version:item.version}">-->

                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select v-model="parentId_two" placeholder="选择一级" clearable
                               style="width: 49%!important;margin-left:2%;" :disabled="disabled_two">
                      <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>

              </tr>
              <tr>

                <th>
<!--                  <em class="f-red">*</em>-->
                  考核类别
                </th>
                <td>
                  <check-subject-search :check-subject-id.sync="company.checkSubjectId"
                                        :check-subject-name.sync="company.checkSubjectName"/>
                  <!--                    <el-input type="text" autocomplete="off" v-model="company.checkSubjectId" clearable />-->
<!--                  <el-select v-model="company.checkSubjectId" placeholder="考核类别" clearable>-->
<!--                    <el-option v-for="item in checkSubjects" :key="item.value" :label="item.label" :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
                </td>
                <th><em class="f-red">*</em>排序</th>
                <td>
                  <el-input-number min="0" max="10" style="width:165px" :controls="false" v-model="company.seq"/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="company.usable">
                      <el-option label="禁用" :value="0"/>
                      <el-option label="启用" :value="1"/>
                    </el-select>
                  </el-form-item>
                </td>
                <!-- <th>
                <em class="f-red">*</em>
                状态
                </th>
              <td>
                <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                  <el-select v-model="company.stat" >
                    <el-option  label="正常" :value="0" />
                    <el-option  label="禁用" :value="1" />
                  </el-select>
                </el-form-item>
              </td> -->
              </tr>

              <tr></tr>
              <tr>
                <th>创建人</th>
                <td>{{ company.createBy }}</td>
                <th>创建时间</th>
                <td>{{ company.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
                           @confirm="confirmCategory"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import {
  fetchTree
} from "@/api/admin/type_tree";
import request from "@/router/axios";
import pager from '@/components/pager/index.vue';
import store from "@/store";
// 城市三级联动
import {
  regionData,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
import CheckSubjectSearch from "@/components/formItem/checkSubjectSearch.vue";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    CheckSubjectSearch,
    Tinymce,
    pager
  },
  data() {
    return {
      first: true,
      customerComplaintTypeEdit: false,
      customerComplaintTypeAdd: false,
      options: [],
      options1: [],
      value: '',
      value2: '',
      tempList: [],
      // 以上大小ID  类型信息
      idName: [],
      upload_btn: false, // 是否隐藏上传图片按钮
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      disabled_one: true,
      disabled_two: true,
      parentId_one: '',
      parentId_two: '',
      checkSubjects: [],
      // 基本信息
      company: {
        id: null,
        companyId: '',
        code: '',
        name: '',
        level: 0,
        parentId: '',
        checkSubjectId: '',
        usable: 1,
        seq: 0
      },
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        usable: 1
      },
      brand: [],
      brandID: {
        // brandName: "string",
        // companyId: 0,
        // current: 0,
        // searchCount: true,
        // size: 0,
        // usable: 0
      },
      showProductCategoryDialog: false,
      languageDTOs: [],
      upload_img: [],
      dialogImageUrl: '',
    };
  },
  computed: {
    // enabled: {}
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    },

    ...mapGetters(["permissions"])
  },
  created() {
    this.customerComplaintTypeEdit = this.permissions['customer_complaint_type_edit']
    this.customerComplaintTypeAdd = this.permissions['customer_complaint_type_add']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {

    this.init();
    this.getData();
    // this.loadCheckSubjects();
    this.levelChange(this.company.level);

  },
  methods: {
    inspection() {
      if (this.company.code) {
        this.$http({
          url: api.basCustomerComplaintType.inspectionUrl,
          method: 'post',
          data: {
            value: this.company.code,
            id: this.company.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("客诉类型编码已存在，请重新输入")
            this.company.code = null
          }
        })
      }
    },


    levelChange(level) {
      if (this.first) {
        this.first = false
      } else {
        this.parentId_two = null
        this.parentId_one = null
      }
      console.log("level", level)
      if (level === 0) {
        this.disabled_one = true;
        this.disabled_two = true;
      } else if (level === 1) {
        this.disabled_one = false;
        this.disabled_two = true;
      } else if (level === 2) {
        this.disabled_one = false;
        this.disabled_two = false;
      }
    },

    // 加载页面
    resetEvent() {
      this.$emit('resetEvent')
    },
    // 大小类型
    selectOne(obj) {
      this.parentId_two = null
      this.init1(obj)
    },
    /*// 上传成功
    handleSuccess(res, file, fileList) {

      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url,"url")
      this.company.picList =[
        {url: res.data.url}
      ]

    },
    handleRemove(response, file, fileList) {
      // 删除成功后，显示上传按钮
      // this.company.picList=[]
      this.upload_btn = false;
      // console.log(this.company.picList,"this.company.picList删除后");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 以上表单事件
    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    // 上传成功*/

    async getData() {
      await this.initMenuData();
    },
    initMenuData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/basCustomerComplaintType/get',
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
          async: false,
        }).then(response => {
          this.company = response.data.data;
          let levelTree = response.data.data.levelTree;
          let levelTreeArray = levelTree.split(",");
          console.log('asdfasdf', levelTreeArray)
          if (this.company.level === 0) {
            this.parentId_one = '';
            this.parentId_two = '';
          } else if (this.company.level === 1) {
            this.parentId_one = levelTreeArray[1];
            this.parentId_two = '';
          } else if (this.company.level === 2) {
            this.init1(this.parentId_one);
            this.parentId_one = levelTreeArray[1];
            this.parentId_two = levelTreeArray[2];
          }
          console.log('asdfsadf', this.parentId_one)
          console.log('asdfsadf', this.parentId_two)
          this.first = true
          this.levelChange(this.company.level);
        })
      } else {
        // this.enabled = true;
      }
    },
    // 加载父级
    init() {
      this.$http({
        url: '/basic/basCustomerComplaintType/getByLevel',
        method: 'post',
        data: {
          "parentId": null,
          "level": 0
        },
        isLoading: true
      }).then(res => {
        this.options = [];
        res.data.data.forEach(item => {
          this.options.push({
            label: item.name,
            value: item.id
          })
        })
      });
    },
    // 加载一级
    init1(obj) {
      this.$http({
        url: '/basic/basCustomerComplaintType/getByLevel',
        method: 'post',
        data: {
          "parentId": obj,
          "level": 1
        },
        isLoading: true
      }).then(res => {
        this.options1 = [];
        res.data.data.forEach(item => {
          this.options1.push({
            label: item.name,
            value: item.id
          })
        })
      });
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.isEdit ? `/basic/basCustomerComplaintType/update` : `/basic/basCustomerComplaintType/save`);
            if (this.company.level === 0) {
              this.company.parentId = '';
            } else if (this.company.level === 1) {
              this.company.parentId = this.parentId_one;
            } else if (this.company.level === 2) {
              this.company.parentId = this.parentId_two;
            }
            this.$http({
              url: url,
              method: `post`,
              data: this.company,
              isLoading: true,
            }).then(() => {
              this.$message.success("保存成功！");
              this.goBackIndex()
              this.$mask.close()

              // this.$emit('editViewDataUpdate');
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()

            });
          });
        }

      });
// this.$refs['table-m1'].commitProxy('reload');
    },
    confirmCategory(rows) {
      if (rows.length > 0) {
        let row = rows[0];
        this.company.itemCatId = row.id;
        this.company.itemCatName = row.categoryName;
        this.company.itemCatCode = row.categoryCode;
      }
    },
    // 地址三级联动
    handleChange() {
      var loc = "";
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]] + "-";
      }
      this.infoForm.province = loc.split("-")[0];
      this.infoForm.city = loc.split("-")[1];
      console.log(loc.split("-"), this.infoForm.province, this.infoForm.city)
    },

    // //初始化加载考核类别
    // loadCheckSubjects() {
    //   this.$http({
    //     url: '/basic/basCheckSubject/list',
    //     method: 'get',
    //     data: {},
    //     isLoading: true
    //   }).then(res => {
    //     this.checkSubjects = [];
    //     res.data.data.forEach(item => {
    //       this.checkSubjects.push({
    //         label: item.name,
    //         value: item.id
    //       })
    //     })
    //   });
    // },
  },
};

</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

</style>
